'use client';

import React, { useState } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HeroSection from './home/components/HeroSection';
import OriginStorySection from './home/components/OriginStorySection';
import MenuSection from './home/components/MenuSection';
import LocationsSection from '@/components/LocationsSection';
import TestimonialsSection from './home/components/TestimonialsSection';
import ContactSection from './home/components/ContactSection';
import BookingModal from './home/components/BookingModal';
import FixedCTABar from './home/components/FixedCTABar';
import FAQSection from './home/components/FAQSection';

export default function HomePage() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="relative min-h-screen">
      <div
        className="fixed inset-0 pointer-events-none z-[9998] opacity-[0.025]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
        }}
      />

      <Header onBookClick={() => setModalOpen(true)} />

      <main>
        <HeroSection onBookClick={() => setModalOpen(true)} />
        <OriginStorySection />
        <MenuSection />
        <LocationsSection />
        <TestimonialsSection />
        <ContactSection />
        <FAQSection />
      </main>

      <Footer />

      <FixedCTABar onBookClick={() => setModalOpen(true)} />

      <BookingModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  );
}